import { GlDisclosureDropdownGroup, GlDisclosureDropdownItem } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { __ } from '~/locale';
import Shortcuts from '../../../behaviors/shortcuts/shortcuts.js?vue3';
import { keysFor, START_SEARCH_PROJECT_FILE } from '~/behaviors/shortcuts/keybindings';
import { keyboardShortcutsDisabled } from '~/behaviors/shortcuts/shortcuts_disabled';
import { InternalEvents } from '../../../tracking/index.js?vue3';
import { FIND_FILE_BUTTON_CLICK } from '~/tracking/constants';
import { showBlameButton } from '~/repository/utils/storage_info_utils';
import PermalinkDropdownItem from './permalink_dropdown_item.vue?vue3';
export default {
    name: 'BlobRepositoryActionsGroup',
    components: {
        GlDisclosureDropdownGroup,
        GlDisclosureDropdownItem,
        PermalinkDropdownItem
    },
    inject: [
        'blobInfo'
    ],
    props: {
        permalinkPath: {
            type: String,
            required: true
        },
        isBinaryFileType: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        findFileShortcutKey () {
            return keysFor(START_SEARCH_PROJECT_FILE)[0];
        },
        shortcutsDisabled () {
            return keyboardShortcutsDisabled();
        },
        blameItem () {
            return {
                text: __('Blame'),
                extraAttrs: {
                    'data-testid': 'blame'
                }
            };
        },
        showBlameButton () {
            // While blame is shown, the header Blame toggle stays visible to turn it off.
            return !this.isBinaryFileType && this.$route.query.blame !== '1' && showBlameButton(this.blobInfo);
        }
    },
    methods: {
        handleFindFile () {
            InternalEvents.trackEvent(FIND_FILE_BUTTON_CLICK);
            Shortcuts.focusSearchFile();
        },
        handleBlame () {
            // The header shares the blob viewer's router, which shows blame when the query changes.
            // Line highlighting sets the hash outside the router, so read it from window.location.
            this.$router.push({
                query: {
                    ...this.$route.query,
                    blame: '1'
                },
                hash: window.location.hash
            });
        }
    }
};
